export const loadResultPage = () => import('../pages/ResultPage')
